import { render, staticRenderFns } from "./LecturePost.vue?vue&type=template&id=285f99ec&"
import script from "./LecturePost.vue?vue&type=script&lang=js&"
export * from "./LecturePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports